/* tslint:disable */

declare var Object: any;
export interface GpsPositionInterface {
  "id"?: number;
  "name"?: number;
  "accuracy"?: number;
  "altitude"?: number;
  "altitudeAccuracy"?: number;
  "heading"?: number;
  "latitude"?: number;
  "longitude"?: number;
  "speed"?: number;
}

export class GpsPosition implements GpsPositionInterface {
  "id": number;
  "name": number;
  "accuracy": number;
  "altitude": number;
  "altitudeAccuracy": number;
  "heading": number;
  "latitude": number;
  "longitude": number;
  "speed": number;
  constructor(data?: GpsPositionInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `GpsPosition`.
   */
  public static getModelName() {
    return "GpsPosition";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of GpsPosition for dynamic purposes.
  **/
  public static factory(data: GpsPositionInterface): GpsPosition{
    return new GpsPosition(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'GpsPosition',
      plural: 'GpsPositions',
      path: 'GpsPositions',
      idName: 'id',
      properties: {
        "id": {
          name: 'id',
          type: 'number'
        },
        "name": {
          name: 'name',
          type: 'number'
        },
        "accuracy": {
          name: 'accuracy',
          type: 'number'
        },
        "altitude": {
          name: 'altitude',
          type: 'number'
        },
        "altitudeAccuracy": {
          name: 'altitudeAccuracy',
          type: 'number'
        },
        "heading": {
          name: 'heading',
          type: 'number'
        },
        "latitude": {
          name: 'latitude',
          type: 'number'
        },
        "longitude": {
          name: 'longitude',
          type: 'number'
        },
        "speed": {
          name: 'speed',
          type: 'number'
        },
      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/sdk/models/GpsPosition.ts